import { useEffect } from 'react';
export const useDebouncedEffect = (effect, deps, delay = 300) => {
    useEffect(() => {
        const handler = setTimeout(() => effect(), delay);
        return () => clearTimeout(handler);
    }, [...(deps || []), delay]);
};
